export enum CCTypes {
  None = "None",
  Visa = "Visa",
  MasterCard = "MasterCard"
}
